export default __webpack_public_path__ + "static/media/pl5.e8dcee04.png";